/** @jsxImportSource @emotion/react */
import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { setCartPaymentInfo } from '../../../autoshipState/autoshipSlice';
import t from '@rcm/i18n-client';
import CardNumberField from '../../AutoshipV2/LeftSection/BillingInfo/BillingForm/CardNumberField';
import { Form } from 'react-final-form';
import { isValidCvv, validateExpDate } from '../../AutoshipV2/customFields/validations';
import { Select, Input } from '../../AutoshipV2/customFields';
import { setDisableSubmitOrder } from 'cart-ui-react/src/autoshipState/autoshipSlice';
import { selectCartPaymentInfo } from 'cart-ui-react/src/autoshipState/selectors';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const CartV2CreditCardFields = () => {
  const dispatch = useDispatch();
  const paymentInfo = useSelector(selectCartPaymentInfo);
  const [formData, setFormData] = useState({
    cardNumber: '',
    nameOnCard: '',
    expirationMonth: '',
    expirationYear: '',
    verificationCode: '',
  });
  const formRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const yearDropdown = () => {
    const optionElements = [];
    const date = new Date().getFullYear();
    for (let i = date; i <= date + 15; i++) {
      optionElements.push(String(i));
    }
    return optionElements;
  };

  const monthDropdown = () => {
    const optionElements = [];
    for (let i = 1; i <= 12; i++) {
      optionElements.push(String(i));
    }
    return optionElements;
  };
  useEffect(() => {
    dispatch(setCartPaymentInfo(formData));
  }, [formData]);

  useEffect(() => {
    if (formRef.current) {
      dispatch(setDisableSubmitOrder(true));
    } else {
      dispatch(setDisableSubmitOrder(false));
    }
  }, [formData, formRef.current]);

  const cardInfoMissing = paymentInfo.cardNumber?.length < 1 ||
    paymentInfo.expirationMonth?.length < 1 ||
    paymentInfo.expirationYear?.length < 1;

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Form
      onSubmit={handleInputChange}
      initialValues={{
        ...formData,
      }}
      validate={validateExpDate}
    >
      {({ hasValidationErrors }) => {
        formRef.current = hasValidationErrors;
        return (
          <Grid container>
            <Grid item xs={12} sm={12} md={6} sx={{ p: 0.5 }}>
              <CardNumberField
                css={{ flex: '1 40%', width: '40%', marginTop: '20px', height: '27px' }}
                onChange={handleInputChange}
                label={t('Card Number')}
                name='cardNumber'
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              alignItems='center'
              sx={{ p: 0.5 }}
            >
              <Box
                sx={{
                  width: 'auto',
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  alignItems: 'flex-start',
                  gap: 1,
                }}
              >
                <Select
                  css={{ minWidth: '24px' }}
                  label={t('Month')}
                  onChange={handleInputChange}
                  name='expirationMonth'
                  required
                  options={[
                    { option: '', value: '' },
                    ...monthDropdown().map((i) => ({
                      option: i,
                      value: i,
                    })),
                  ]}
                />
                <Select
                  css={{ minWidth: '24px' }}
                  onChange={handleInputChange}
                  label={t('Year')}
                  name='expirationYear'
                  required
                  options={[
                    { option: '', value: '' },
                    ...yearDropdown().map((i) => ({
                      option: i,
                      value: i,
                    })),
                  ]}
                />
              </Box>
            </Grid>

            {isMobile ?
              <>
                <Grid item xs={12} md={3} sx={{ p: 0.5 }}>
                  <Input
                    // disabled={cardInfoMissing} disabling for the time being, this could be causing problems with autofill
                    css={{ width: '66px', height: '27px' }}
                    label='CVV'
                    type='text'
                    name='verificationCode'
                    onChange={handleInputChange}
                    validate={isValidCvv}
                  />
                </Grid>
                <Grid item xs={12} md={9} sx={{ p: 0.5 }}>
                  <Input
                    css={{ flex: '1 40%', width: 'auto', height: '27px' }}
                    label={t('Name on Card')}
                    type='text'
                    name='nameOnCard'
                    onChange={handleInputChange}
                    required
                  />
                </Grid>
              </>
            :
              <>
                <Grid item xs={12} md={9} sx={{ p: 0.5 }}>
                  <Input
                    css={{ flex: '1 40%', width: 'auto', height: '27px' }}
                    label={t('Name on Card')}
                    type='text'
                    name='nameOnCard'
                    onChange={handleInputChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={3} sx={{ p: 0.5 }}>
                  <Input
                    // disabled={cardInfoMissing}
                    css={{ width: '66px', height: '27px' }}
                    label='CVV'
                    type='text'
                    name='verificationCode'
                    onChange={handleInputChange}
                    validate={isValidCvv}
                  />
                </Grid>
              </>
            }
          </Grid>
        );
      }}
    </Form>
  );
};

export default CartV2CreditCardFields;
